
        <div class="modal-header panel-heading">
            <h2 class="modal-title">{{"sow.createNewTitle" | translate}}</h2>
            <button type="button" class="close" (click)="onClose()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            @if(SowDataForm) {
            <form [formGroup]="SowDataForm">
                <div class="form-group mt-lg px-2">
                    <div class="row">
                        <div class="col-6 mt-3">
                            <div class="form-label">
                                {{ "labels.startDate" | translate }}
                            </div>
                            <input class="form-control" placeholder="dd-mm-yyyy" name="deadline" formControlName="startDate" ngbDatepicker
                                (click)="startPicker.toggle()" #startPicker="ngbDatepicker">
                        </div>
                        <div class="col-6  mt-3">
                            <div class="form-label">
                                {{ "labels.endDate" | translate }}
                            </div>
                            <input class="form-control" placeholder="dd-mm-yyyy" name="deadline" formControlName="endDate" ngbDatepicker
                                (click)="endPicker.toggle()" #endPicker="ngbDatepicker">

                        </div>
                        <div class="col-6  mt-3">
                            <div class="form-label">
                                {{ "sow.form.poNumber" | translate }}
                            </div>
                            <input type="text" class="form-control" formControlName="po">

                        </div>
                        <div class="col-6  mt-3">
                            <div class="form-label">
                                {{ "sow.form.caseNumber" | translate }}
                            </div>
                            <input type="text"  class="form-control" formControlName="caseNumber">
                        </div>
                        <div class="col-6  mt-3">
                            <div class="form-label">
                                {{ "sow.form.budget" | translate }}
                            </div>
                            <input type="text" class="form-control" formControlName="budget">
                        </div>
                        <div class="col-6"></div>
                        <div class="col-12  mt-3">
                            <div class="form-label">
                                {{ "sow.form.comment" | translate }}
                            </div>
                            <textarea cols="3" class="form-control" formControlName="comment"></textarea>
                        </div>
                        </div>

                </div>

            </form>
            }

        </div>
        <div class="sow-modal-footer">
            <button class="btn btn-primary ml-3" (click)="onSave()">
                {{ "labels.save" | translate }}
            </button>
            <button class="btn btn-danger ml-3" (click)="onClose()">
                {{ "labels.cancel" | translate }}
            </button>
        </div>
